import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateRmCH: NDateLocale = {
  name: 'rm-CH',
  locale: enUS
}

export default dateRmCH
